import { RadioButton } from 'primereact/radiobutton';
import "./RadioButton.scss";

const RadioBtn = ({
    fieldName = "default",
    options = [],
    selectedValue = "",
    handleChange = () => { },
    styles = {},
    labelStyles = {},
    radioStyles = {},
    customLabelName = "",
    required = false,
    optionStyles = "",
    hasError = false
}) => {
    const labelName = fieldName
        ? fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase() + ":"
        : "Field Name";

    return (
        <div style={styles} className="radioBtnMainContainer">
            <label style={labelStyles} className="label">
                {customLabelName ? customLabelName : labelName}
                {required && <sup style={{ fontWeight: "700", color: "red", fontSize: "1.3rem" }}>*</sup>}
            </label>
            <div style={{ width: "100%", display: "flex", backgroundColor: "white", justifyContent: "space-evenly", alignItems: "center", borderRadius: "5px", padding: "clamp(10px, 3vw, 18px)" }}>
                {options.map((option, index) => (
                    <div style={radioStyles} key={index}>
                        <RadioButton
                            inputId={`${fieldName}-${option.value}`}
                            name={fieldName}
                            value={option.value}
                            onChange={(e) => handleChange(e.value)}
                            checked={selectedValue === option.value}
                            invalid = {hasError}
                        />
                        <label htmlFor={`${fieldName}-${option.value}`} style={optionStyles}>{option.label}</label>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RadioBtn;
